
import api from './api';
import parseGooglePlace from 'parse-google-place';

class Store {

	constructor (Api) {
		this.Api = Api;
	}

	move (storeId, zoneId) {
		return this.Api.put({
			url:  'v1.1/m/stores/'+storeId+'/zone/'+zoneId
		});
	}
	
	create(store){
		return this.Api.post({
			url:  'v1.1/m/stores',
			body: generatePayload(store)
		}).then(response => response.stores);
	}

}




Store.$inject = ['Api'];

export default angular.module('service.store', [api])
	.service('Store', Store)
	.name;

function generatePayload (store) {
	var parsedAddress = parseGooglePlace(store.address);
	return {
		name: store.name,
		address: store.address.formatted_address,
		addressCountry: parsedAddress.countryShort, 
		addressLocality: parsedAddress.county,
		addressRegion: parsedAddress.stateShort,
		postalCode: parsedAddress.zipCode,
		streetAddress: parsedAddress.address,
		lat: store.address.geometry.location.lat(),
		lng: store.address.geometry.location.lng(), 
		phoneNumber: store.phone,
		zoneId: store.zone
	};
}



// WEBPACK FOOTER //
// ./src/service/store.js